import ImageContainers, { ImageContainersProps } from './ImageContainers';

export type { ImageContainersProps };
export default ImageContainers;
